<script lang="ts" setup>
import completeYourProfileIcon from '@images/svg/complete-your-profile.svg'

const isDialogCompleteProfile = defineModel({
    type: Boolean,
    default: false
})

const { t } = useI18n()
</script>

<template>
    <VDialog v-model="isDialogCompleteProfile" width="500">
        <!-- Dialog Content -->
        <VCard>
            <DialogCloseBtn
                variant="text"
                size="default"
                @click="isDialogCompleteProfile = false"
            />

            <VCardText class="pt-5">
                <div class="text-center mb-6 mt-10">
                    <Component :is="completeYourProfileIcon" />
                    <h4 class="text-h4 mb-2">
                        {{ t('Complete Your Profile') }}
                    </h4>
                    <p>
                        {{
                            t(
                                'Complete your profile to start applying for jobs right away.'
                            )
                        }}
                    </p>
                    <div class="d-flex ga-2 justify-center">
                        <VBtn
                            color="primary"
                            to="/profile"
                            @click="isDialogCompleteProfile = false"
                            >{{ t('Update Profile') }}</VBtn
                        >
                        <VBtn
                            variant="outlined"
                            @click="isDialogCompleteProfile = false"
                            >{{ t('Later') }}</VBtn
                        >
                    </div>
                </div>
            </VCardText>
        </VCard>
    </VDialog>
</template>
